module.exports = __webpack_public_path__ + "static/img/emotion-people.bd83f66a.png";